/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:inline-block;fill:currentColor;height:24px;width:24px}[_nghost-%COMP%]     svg{display:block;height:100%;width:100%}"];
export { styles as styles };
